






































import SwitchByUa from '@/components/atoms/SwitchByUa.vue'
import SpaErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import { log } from '@/log'
import { ApiContent } from '@/models/api/content'
import FreeAreaService from '@/services/free-area/free-area'
import { OrderHistoryFreeArea } from '@/services/free-area/order-history/order-history-free-area'
import HeaderBottomUserNotification from '@ajax/vue/components/templates/HeaderBottomUserNotification.vue'
import { HlAppModeMixin } from '@spa/mixins/hl-app-mode'
import { Status } from '@spa/mixins/loading'
import { Mixins } from 'vue-mixin-decorator'
import { Component } from 'vue-property-decorator'
import { PluginMixin } from '../../../../mixins/plugin'

import * as CurrentTime from '@/models/current-time/functions'
import { EventBusForThirdParty } from '@/usecases/event-bus-for-third-party/event-bus'
import BackToMyPageTopButton from '@spa/components/organisms/mypage/BackToMypPageTopButton.vue'
import { User } from '@spa/store/modules/user/types'
import HistoryPage from './HistoryPage.vue'

@Component({
  components: {
    SpaErrorDialog,
    HistoryPage,
    SwitchByUa,
    /**
     * 本当はSPA内全ページに埋め込まれるように、Default.vueなどに実装したかったが、
     * 以下の理由で断念し、ピンポイントで必要な箇所に実装する方針とした。
     *
     * ヘッダーの下に入りこまないように.l-containerがpadding-topを持っているので、
     * .l-containerの中にHeaderBottomUserNotificationを入れる必要があった。
     * （なおAjax時には.l-containerのpadding-topは上書きされ0pxとなっている）
     *
     * SPA/Ajax全体のヘッダーに対するコンテンツのpadding-topの考え方は整理したほうが良さそう
     * 関連：
     * @see https://github.com/Everforth/growthpalette-front/issues/7997
     */
    HeaderBottomUserNotification,
    BackToMyPageTopButton,
  },
})
export default class History extends Mixins<PluginMixin & HlAppModeMixin>(PluginMixin, HlAppModeMixin) {

  status: Status = Status.Pending

  freeAreaService: FreeAreaService = FreeAreaService.createForHost(OrderHistoryFreeArea)

  pageNumber: number = 0

  headerFreeArea: ApiContent = ApiContent.empty

  showModal: boolean = false

  modalMessage: string = ''

  get user(): User {
    return this.$store.state.user.user
  }

  async created() {
    this.status = Status.Loading

    try {
      await Promise.all([
        this.loadFreeArea(),
        this.loadUserData(),
        this.addNewPage(1),
      ])
      this.status = Status.Completed

      EventBusForThirdParty.getInstance().publish('page-initialized', {
        url: window.location.href,
        initializedAt: CurrentTime.create().now,
        user: this.user,
      })
    } catch (error) {
      log.error(error)

      this.status = Status.Failed
    }
  }

  async loadFreeArea(): Promise<void> {
    if (this.hlAppMode.isPageForHlApp) {
      return Promise.resolve()
    }

    const [header] = await this.freeAreaService.fetch()
    this.headerFreeArea = header || ApiContent.empty
  }

  async loadUserData(): Promise<void> {
    await this.$store.dispatch('user/get')
  }

  async addNewPage(pageNumber: number): Promise<void> {
    try {
      await this.$store.dispatch('orderHistory/addPage', {
        force: false,
        pageNumber,
      })

      this.pageNumber = pageNumber
      this.scrollToTop()
    } catch (error) {
      this.showModal = true
      this.modalMessage = '購入履歴が取得できませんでした。'

      throw error
    }
  }

  async onNewPageSelect(pageNumber: number) {
    this.status = Status.Loading
    try {
      await this.addNewPage(pageNumber)
      this.pageNumber = pageNumber

      this.status = Status.Completed
    } catch (e) {
      log.error(e)

      this.status = Status.Failed
    }
  }

  /**
   * FIXME: There are similar copy-paste codes.
   */
  scrollToTop() {
    const scrolled = (window.pageYOffset !== undefined) ? window.pageYOffset : document.documentElement.scrollTop

    // tslint:disable-next-line
    window.scrollTo(0, Math.floor(scrolled / 2))
    if (scrolled > 0) {
      // tslint:disable-next-line
      window.setTimeout(this.scrollToTop, 30);
    }
  }
}
